module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "share-button"
  }, [_c('button', {
    class: _vm.$i18n.locale() == 'ar' ? 'btn btn-success btn-xs pull-left' : 'btn btn-success btn-xs pull-right',
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$store.commit('setShowShare', true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Share')))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-top-title"
  }, [_vm._v(_vm._s(_vm.$t('Settings')))]), _vm._v(" "), _c('label', {
    staticClass: "label label-warning"
  }, [_vm._v(_vm._s(_vm.$t('Page is under-construction')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.oldPass),
      expression: "oldPass"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "oldpassword",
      "aria-describedby": "oldpass-addon1",
      "type": "password",
      "placeholder": _vm.$t('Old Password')
    },
    domProps: {
      "value": _vm.oldPass,
      "value": (_vm.oldPass)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.oldPass = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass1),
      expression: "newPass1"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newpassword1",
      "aria-describedby": "newPass1-addon1",
      "type": "password",
      "placeholder": _vm.$t('New Password')
    },
    domProps: {
      "value": _vm.newPass1,
      "value": (_vm.newPass1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass1 = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPass2),
      expression: "newPass2"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "newpassword2",
      "aria-describedby": "newPass1-addon1",
      "type": "password",
      "placeholder": _vm.$t('Confirm Password')
    },
    domProps: {
      "value": _vm.newPass2,
      "value": (_vm.newPass2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPass2 = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t('Change Password')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "oldpass-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "newPass1-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-lock fa-fw",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85a8eb86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
// module id = 315
// module chunks = 1